export const A = {
  SAVE_PRODUCTS_PAGE_STATE: 'SAVE_PRODUCTS_PAGE_STATE',
};

export const saveProductsPageState = (data) => {
  return {
    type: A.SAVE_PRODUCTS_PAGE_STATE,
    data,
  };
};
